<template>
    <Modal @shown="shown" @hidden="hidden" ref="modal" @submit="submit" modalClass="modal-md">
        <template #title>
            {{ i18n('Edit profiles') + (application.name ? ' ' + application.name : '') }}
        </template>
        <div class="alert alert-danger mb-2" v-if="errorMessage">{{ errorMessage }}</div>

        <div v-if="deleteProfiles.length">
            <h5>{{ i18n('Profiles to be deleted') }}</h5>
            <ul>
                <li v-for="profile in deleteProfiles" :key="profile.id">
                    {{ profile.name }}
                </li>
            </ul>
        </div>

        <div v-if="addProfiles.length">
            <h5>{{ i18n('Profiles to be added') }}</h5>
            <ul>
                <li v-for="profile in addProfiles" :key="profile.id">
                    {{ profile.name }}
                </li>
            </ul>
        </div>

        <div class="text-end mb-3">
            <a href="#" @click.prevent="changeShowExpirations">{{ i18n(showExpirations ? 'Hide expiration' : 'Show expiration') }}</a>
        </div>

        <div v-if="showExpirations && addProfiles.length > 0 && $root.features?.profiles?.expiration">
            <h5>{{ i18n('Set expirations') }}</h5>
            <Field class="mb-3" :disabled="submitted" type="date" :required="false" :customAutofocus="true"
                        :label="i18n('Expiration Date')" v-model="expires_at"
                        :errorMessage="errorMessages.expires_at" />
            <div class="d-flex justify-content-between mb-2 mt-2 align-items-center border-bottom" v-for="profile in addProfiles"
                :key="profile.id">
                {{ profile.name }}
                <Field :disabled="submitted" type="checkbox" label="" v-model="profile.is_expiring" />
            </div>
        </div>

        <template #footer>
            <div class="row">
                <div class="col text-end">
                    <button type="submit" class="btn btn-dark btn-sm" :disabled="submitted">
                        {{ i18n('Save') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>
<script>

import api from "../../api";
import Modal from "@/components/common/layout/Modal.vue";
import Field from "@/components/common/form/Field.vue";
import { translatedErrorMessage, } from "@/tools/errorHandling.js";

export default {
    components: {
        Modal,
        Field,
    },
    data() {
        return {
            submitted: false,
            errorMessages: {},
            errorMessage: '',
            application: {},
            deleteProfiles: [],
            addProfiles: [],
            expires_at: null,
            showExpirations: false,
        };
    },
    props: {},
    emits: [
        'shown',
        'hidden',
        'submit',
        'updated',
    ],
    mounted() {},
    methods: {
        load() {
            this.$refs['modal'].show();
        },
        show($event) {
            this.application = $event.application;
            this.user = $event.user;
            this.deleteProfiles = $event.deleteProfiles;
            this.addProfiles = $event.addProfiles;
            this.submitted = false;
            this.errorMessage = '';
            this.expires_at = null;

            this.load();
        },
        hide() {
            this.$refs['modal'].hide();
        },
        shown() {
            this.$emit('shown');
        },
        hidden() {
            this.$emit('hidden');
        },
        submit() {
            this.submitted = true;
            this.errorMessage = '';

            const processRequests = async () => {
                try {
                    // Process delete requests one by one
                    for (const profile of this.deleteProfiles) {
                        await api.delete(`users/${this.user.id}/profiles/${profile.id}`);
                    }

                    let someProfileIsExpiring = this.addProfiles.some(profile => profile.is_expiring);

                    if (someProfileIsExpiring && !this.expires_at) {
                        this.errorMessage = this.i18n('Expiration date is required if any profile is marked to expire.');
                        this.submitted = false;
                        return;
                    }

                    if (!someProfileIsExpiring && this.expires_at) {
                        this.errorMessage = this.i18n('Expiration date should not be set if no profile is marked to expire.');
                        this.submitted = false;
                        return;
                    }

                    // Process add requests one by one
                    for (const profile of this.addProfiles) {
                        await api.post(`users/${this.user.id}/profiles/${profile.id}`, {
                            expires_at: profile.is_expiring ? this.expires_at : null,
                        });
                    }

                    this.$emit('updated');
                    this.hide();
                } catch (error) {
                    this.errorMessage = translatedErrorMessage(error);
                } finally {
                    this.submitted = false;
                }
            };

            processRequests();
        },
        changeShowExpirations() {
            this.showExpirations = !this.showExpirations;
        },
    },
};
</script>